
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Modal, Button, Table, Alert, Form, InputGroup, FormControl, Card } from 'react-bootstrap';
import { FaEdit, FaTrash, FaSearch, FaPlus, FaMoneyBillWave, FaCalendarAlt, FaFileSignature, FaMapMarkerAlt, FaFileAlt, FaImage, FaUniversity, FaUserPlus, FaSlidersH } from 'react-icons/fa';

const PositionEditor = () => {
  const [formData, setFormData] = useState({
    nombanque: '',
    piece: '',
    positionsMontant: {
      x: 0,
      y: 0,
      fontSize: 12,
      fontFamily: 'Arial',
      lineNumber: 1,
      caracter: 0
    },
    positionsMontantLettre: {
      x: 0,
      y: 0,
      fontSize: 12,
      fontFamily: 'Arial',
      lineNumber: 1,
      caracter: 0
    },
    positionorder_a: {
      x: 0,
      y: 0,
      fontSize: 12,
      fontFamily: 'Arial'
    },
    positionfait_a: {
      x: 0,
      y: 0,
      fontSize: 12,
      fontFamily: 'Arial'
    },
    positionDate: {
      x: 0,
      y: 0,
      fontSize: 12,
      fontFamily: 'Arial'
    },
    positionType: {
      x: 0,
      y: 0,
      fontSize: 12,
      fontFamily: 'Arial'
    },
    image: null,
    imagePreview: null,
    chequeImage: '/blank_cheque.png'
  });

  const [positions, setPositions] = useState([]);
  const [filteredPositions, setFilteredPositions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedElement, setSelectedElement] = useState('positionsMontant');
  const chequeRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [dragField, setDragField] = useState(null);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

  useEffect(() => {
    fetchPositions();
  }, []);

  useEffect(() => {
    if (searchTerm === '') {
      setFilteredPositions(positions);
    } else {
      const filtered = positions.filter(position =>
        position.nombanque.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (position.piece && position.piece.toLowerCase().includes(searchTerm.toLowerCase()))
      );
      setFilteredPositions(filtered);
    }
  }, [searchTerm, positions]);

const fetchPositions = async () => {
  try {
    const response = await axios.get('https://gce.iasoft.ma/api/positions');
    setPositions(response.data);
    setFilteredPositions(response.data);
  } catch (error) {
    console.error('Error fetching positions:', error);
    setError('Erreur lors de la récupération des positions');
  }
};


  const handleStyleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData({
          ...formData,
          image: file,
          imagePreview: reader.result,
          chequeImage: reader.result
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const loadDefaultCheque = () => {
    setFormData({
      ...formData,
      chequeImage: '/blank_cheque.png',
      image: null,
      imagePreview: null
    });
  };


  const handleSubmit = async (e) => {
  e.preventDefault();

  const formDataToSend = new FormData();
  formDataToSend.append('nombanque', formData.nombanque);
  formDataToSend.append('piece', formData.piece);
  formDataToSend.append('positionsMontant', JSON.stringify(formData.positionsMontant));
  formDataToSend.append('positionsMontantLettre', JSON.stringify(formData.positionsMontantLettre));
  formDataToSend.append('positionorder_a', JSON.stringify(formData.positionorder_a));
  formDataToSend.append('positionfait_a', JSON.stringify(formData.positionfait_a));
  formDataToSend.append('positionDate', JSON.stringify(formData.positionDate));
  formDataToSend.append('positionType', JSON.stringify(formData.positionType));

  if (formData.image instanceof File) {
    formDataToSend.append('image', formData.image);
  }

  const baseUrl = 'https://gce.iasoft.ma';

  try {
    let response;
    if (editingId) {
      response = await axios.post(`${baseUrl}/api/positions/${editingId}?_method=PUT`, formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept': 'application/json',
        },
      });
    } else {
      response = await axios.post(`${baseUrl}/api/positions`, formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept': 'application/json',
        },
      });
    }

    if (response.status === 200 || response.status === 201) {
      setSuccess(editingId ? 'Position mise à jour avec succès' : 'Position ajoutée avec succès');
      fetchPositions();
      setShowModal(false);
    } else {
      setError('Erreur lors de l\'enregistrement');
    }
  } catch (error) {
    console.error('Error:', error);
    setError('Erreur lors de l\'enregistrement');
  }
};

const handleEdit = (position) => {
  const baseUrl = 'https://gce.iasoft.ma';

  setEditingId(position.id);
  setFormData({
    nombanque: position.nombanque,
    piece: position.piece || '',
    positionsMontant: typeof position.positionsMontant === 'string'
      ? JSON.parse(position.positionsMontant)
      : position.positionsMontant,
    positionsMontantLettre: typeof position.positionsMontantLettre === 'string'
      ? JSON.parse(position.positionsMontantLettre)
      : position.positionsMontantLettre,
    positionorder_a: typeof position.positionorder_a === 'string'
      ? JSON.parse(position.positionorder_a)
      : position.positionorder_a,
    positionfait_a: typeof position.positionfait_a === 'string'
      ? JSON.parse(position.positionfait_a)
      : position.positionfait_a,
    positionDate: typeof position.positionDate === 'string'
      ? JSON.parse(position.positionDate)
      : position.positionDate,
    positionType: typeof position.positionType === 'string'
      ? JSON.parse(position.positionType)
      : position.positionType,
    image: null,
    imagePreview: position.image ? `${baseUrl}/images/${position.image}` : null,
    chequeImage: position.image ? `${baseUrl}/images/${position.image}` : '/blank_cheque.png'
  });
  setShowModal(true);
};

const handleDelete = async (id) => {
  if (window.confirm('Êtes-vous sûr de vouloir supprimer cette position ?')) {
    try {
      const baseUrl = 'https://gce.iasoft.ma';
      await axios.delete(`${baseUrl}/api/positions/${id}`);
      setSuccess('Position supprimée avec succès');
      fetchPositions();
    } catch (error) {
      console.error('Error deleting position:', error);
      setError('Erreur lors de la suppression de la position');
    }
  }
};


  const resetForm = () => {
    setFormData({
      nombanque: '',
      piece: '',
      positionsMontant: {
        x: 0,
        y: 0,
        fontSize: 12,
        fontFamily: 'Arial',
        lineNumber: 1,
        caracter: 0
      },
      positionsMontantLettre: {
        x: 0,
        y: 0,
        fontSize: 12,
        fontFamily: 'Arial',
        lineNumber: 1,
        caracter: 0
      },
      positionorder_a: {
        x: 0,
        y: 0,
        fontSize: 12,
        fontFamily: 'Arial'
      },
      positionfait_a: {
        x: 0,
        y: 0,
        fontSize: 12,
        fontFamily: 'Arial'
      },
      positionDate: {
        x: 0,
        y: 0,
        fontSize: 12,
        fontFamily: 'Arial'
      },
      positionType: {
        x: 0,
        y: 0,
        fontSize: 12,
        fontFamily: 'Arial'
      },
      image: null,
      imagePreview: null,
      chequeImage: '/blank_cheque.png'
    });
    setEditingId(null);
  };

  return (
    <div className="position-editor-container">
      <style jsx global>{`
        .position-editor-container {
          padding: 2rem;
          background-color:rgb(255, 255, 255);
          min-height: 100vh;
          Width:50%;
        }

        .header-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 2rem;
          flex-wrap: wrap;
          gap: 1rem;
        }

        .page-title {
          color: #2c3e50;
          font-weight: 600;
          margin: 0;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .action-buttons {
          display: flex;
          gap: 1rem;
        }

        .search-section {
          max-width: 500px;
          margin-bottom: 1.5rem;
        }

        .position-table {
          background-color: white;
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
          border-radius: 0.5rem;
          overflow: hidden;
        }

        .table-header {
          background-color: #2c3e50;
          color: white;
        }

        .table-header th {
          font-weight: 500;
          padding: 1rem;
        }

        .modal-content {
          border-radius: 10px;
          border: none;
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.2);
        }

        /* Modal Styles */
        .modal-content {
          border-radius: 0.5rem;
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
          border: none;
        }

        .modal-header {
          background-color: #2c3e50;
          color: white;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          border-top-left-radius: 0.5rem;
          border-top-right-radius: 0.5rem;
          padding: 1rem 1.5rem;
        }

        .modal-title {
          font-size: 1.5rem;
          font-weight: 600;
          display: flex;
          align-items: center;
        }

        .modal-body {
          padding: 1.5rem;
          background-color: #f8f9fa;
        }

        /* Form Styles */
        .form {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .row {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -0.75rem;
        }

        .col-md-6 {
          flex: 0 0 50%;
          max-width: 50%;
          padding: 0 0.75rem;
          margin-bottom: 1rem;
        }

        .form-group {
          margin-bottom: 1rem;
        }

        .form-label {
          font-size: 0.9rem;
          font-weight: 500;
          margin-bottom: 0.5rem;
          display: block;
          color: #495057;
        }

        .form-control {
          padding: 0.6rem 0.9rem;
          font-size: 0.9rem;
          border: 1px solid #ced4da;
          border-radius: 0.25rem;
          width: 100%;
          transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        }

        .form-control:focus {
          border-color: #80bdff;
          box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
        }

        .form-select {
          padding: 0.6rem 0.9rem;
          font-size: 0.9rem;
          border: 1px solid #ced4da;
          border-radius: 0.25rem;
          width: 100%;
          background-color: white;
          transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        }

        .form-select:focus {
          border-color: #80bdff;
          box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
        }

        /* Range Input Styles */
        .range-container {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          margin-bottom: 1rem;
        }

        .range-label {
          font-size: 0.85rem;
          font-weight: 500;
          color: #495057;
        }

        .custom-range {
          height: 8px;
          padding: 0;
          margin: 0;
          -webkit-appearance: none;
          appearance: none;
          background: #e9ecef;
          border-radius: 4px;
          width: 100%;
        }

        .custom-range::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 16px;
          height: 16px;
          background: #2c3e50;
          border-radius: 50%;
          cursor: pointer;
          border: 2px solid white;
        }

        .custom-range::-moz-range-thumb {
          width: 16px;
          height: 16px;
          background: #2c3e50;
          border-radius: 50%;
          cursor: pointer;
          border: 2px solid white;
        }

        /* Button Styles */
        .btn {
          padding: 0.5rem 1.25rem;
          font-size: 0.9rem;
          font-weight: 500;
          border-radius: 0.25rem;
          cursor: pointer;
          transition: all 0.2s ease-in-out;
          border: none;
        }

        .btn-primary {
          background-color: #2c3e50;
          color: white;
        }

        .btn-primary:hover {
          background-color: #1a252f;
          color: white;
        }

        .btn-outline-secondary {
          color: #6c757d;
          border: 1px solid #6c757d;
          background-color: transparent;
          margin-right: 0.75rem;
        }

        .btn-outline-secondary:hover {
          background-color: #6c757d;
          color: white;
        }

        /* Preview Container Styles */
        .cheque-preview-container {
          position: relative;
          border: 1px solid #dee2e6;
          border-radius: 0.25rem;
          overflow: hidden;
          margin: 0 auto;
          background-color: #f9f9f9;
          box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
        }

        .cheque-background {
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          width: 100%;
          height: 100%;
          position: absolute;
          opacity: 0.7;
          top: 0;
          left: 0;
        }

        .cheque-element {
          position: absolute;
          padding: 0.3rem 0.6rem;
          background-color: rgba(255, 255, 255, 0.8);
          border: 1px dashed #6c757d;
          border-radius: 0.2rem;
          cursor: move;
          user-select: none;
          box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
          transition: all 0.2s ease-in-out;
          z-index: 1;
        }

        .cheque-element.active-element {
          background-color: white;
          border: 1px solid #2c3e50;
          box-shadow: 0 0 0 0.2rem rgba(44, 62, 80, 0.25);
          z-index: 10;
        }

        .cheque-element:hover {
          background-color: white;
          border: 1px solid #2c3e50;
        }

        /* Position Controls Styles */
        .position-controls {
          background-color: white;
          padding: 1.25rem;
          border-radius: 0.25rem;
          margin-bottom: 1.5rem;
          box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
        }

        .position-controls h5 {
          font-size: 1.1rem;
          margin-bottom: 1rem;
          color: #2c3e50;
          display: flex;
          align-items: center;
        }

        /* Icon Styles */
        .me-2 {
          margin-right: 0.5rem;
        }

        /* Responsive Styles */
        @media (max-width: 768px) {
          .modal-dialog {
            max-width: 95%;
            margin: 1.75rem auto;
          }

          .col-md-6 {
            flex: 0 0 100%;
            max-width: 100%;
          }

          .range-container {
            flex-direction: column;
          }
        }

        /* Utility Classes */
        .fw-bold {
          font-weight: 600 !important;
        }

        .text-primary {
          color: #2c3e50 !important;
        }

        .bg-light {
          background-color: white !important;
        }

        .mb-3 {
          margin-bottom: 1rem !important;
        }

        .mb-4 {
          margin-bottom: 1.5rem !important;
        }

        .p-3 {
          padding: 1rem !important;
        }

        .p-4 {
          padding: 1.5rem !important;
        }

        .rounded {
          border-radius: 0.25rem !important;
        }

        .border {
          border: 1px solid #dee2e6 !important;
        }

        .d-flex {
          display: flex !important;
        }

        .justify-content-end {
          justify-content: flex-end !important;
        }

        .waw {
          padding: 0.5rem 1.5rem;
          font-size: 0.95rem;
          font-weight: 500;
          background-color:rgb(2, 24, 46);
          color: white;
          border: none;
          border-radius: 0.25rem;
          transition: background-color 0.2s ease-in-out;
          margin-right:40%        }

        .waw:hover {
          background-color: #1a252f;
        }

        /* Custom styles for better appearance */
        .form-section {
          background-color: white;
          padding: 1.5rem;
          border-radius: 0.5rem;
          box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
          margin-bottom: 1.5rem;
        }

        .form-section-title {
          font-size: 1.2rem;
          color: #2c3e50;
          margin-bottom: 1rem;
          padding-bottom: 0.5rem;
          border-bottom: 1px solid #eee;
          display: flex;
          align-items: center;
        }

        .btn-custom-primary {
          background-color: #2c3e50;
          color: white;
          border: none;
          padding: 0.5rem 1.25rem;
          border-radius: 0.25rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          transition: all 0.2s ease-in-out;
        }

        .btn-custom-primary:hover {
          background-color: #1a252f;
          color: white;
          transform: translateY(-1px);
        }

        .btn-custom-primary:active {
          transform: translateY(0);
        }

        .btn-custom-primary i {
          margin-right: 0.5rem;
        }
      `}</style>

      {error && (
        <Alert variant="danger" onClose={() => setError(null)} dismissible className="mb-3">
          {error}
        </Alert>
      )}
      {success && (
        <Alert variant="success" onClose={() => setSuccess(null)} dismissible className="mb-3">
          {success}
        </Alert>
      )}

      <div className="header-section">
        <h2 className="page-title">
          <FaUniversity /> Gestion des Banques
        </h2>
      </div>

      <div className="header-section">
        <div className="action-buttons d-flex align-items-center">
          <Button className="btn-custom-primary" onClick={() => { resetForm(); setShowModal(true); }}>
            <FaUserPlus className="me-2" />
            Ajouter
          </Button>
        </div>
      </div>

      <div className="search-section mb-4">
        <InputGroup>
          <FormControl
            placeholder="Rechercher par nom de banque ou pièce..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <InputGroup.Text>
            <FaSearch />
          </InputGroup.Text>
        </InputGroup>
      </div>

      <div className="table-responsive">
        <Table striped bordered hover className="position-table">
          <thead className="table-header">
            <tr>
              <th style={{ width: '100px' }}>Actions</th>
              <th>Banque</th>
              <th>Pièce</th>
              <th>Modèle</th>
            </tr>
          </thead>
          <tbody>
            {filteredPositions.length > 0 ? (
              filteredPositions.map(position => (
                <tr key={position.id}>
                  <td>
                    <div className="d-flex gap-1">
                      <Button
                        variant="outline-warning"
                        size="sm"
                        onClick={() => handleEdit(position)}
                        title="Modifier"
                      >
                        <FaEdit />
                      </Button>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => handleDelete(position.id)}
                        title="Supprimer"
                      >
                        <FaTrash />
                      </Button>
                    </div>
                  </td>
                  <td className="align-middle fw-semibold">{position.nombanque}</td>
                  <td className="align-middle">{position.piece || '-'}</td>
                  <td>
  {position.image ? (
    <img
      src={`https://gce.iasoft.ma/images/${position.image}`}
      alt={position.nombanque}
      className="img-thumbnail"
      style={{ width: '100px', height: 'auto' }}
    />
  ) : (
    <div className="text-muted">Aucun modèle</div>
  )}
</td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center py-4">
                  <div className="text-muted">Aucune banque trouvée</div>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl" centered  > 
<Modal.Header closeButton style={{ backgroundColor: 'rgb(2, 24, 46)', color: 'white' }}>
          <Modal.Title>
            {editingId ? (
              <>
                <FaEdit className="me-2" /> Modifier configuration
              </>
            ) : (
              <>
                <FaPlus className="me-2" /> Nouvelle configuration
              </>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form onSubmit={handleSubmit} className='form'>
            <div className="row mb-4">
              <div className="col-md-6">
                <Form.Group>
                  <Form.Label className="fw-bold">
                    <FaUniversity className="me-2" /> Banque
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.nombanque}
                    onChange={e => setFormData({ ...formData, nombanque: e.target.value })}
                    required
                    placeholder="Ex: Banque Populaire"
                  />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group>
                  <Form.Label className="fw-bold">
                    <FaFileAlt className="me-2" /> Type de document
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.piece}
                    onChange={e => setFormData({ ...formData, piece: e.target.value })}
                    placeholder="Ex: Chèque, Effet"
                  />
                </Form.Group>
              </div>
            </div>

            <div className="position-controls bg-light p-3 rounded mb-4">
              <h5 className="mb-3 text-primary">
                <FaSlidersH className="me-2" /> Configuration de l'élément
              </h5>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <Form.Group>
                    <Form.Label className="fw-bold">Élément sélectionné</Form.Label>
                    <Form.Select
                      value={selectedElement}
                      onChange={e => setSelectedElement(e.target.value)}
                    >
                      <option value="positionsMontant">Montant</option>
                      <option value="positionsMontantLettre">Montant en lettres</option>
                      <option value="positionorder_a">Ordre à</option>
                      <option value="positionfait_a">Fait à</option>
                      <option value="positionDate">Date</option>
                      <option value="positionType">Type</option>
                    </Form.Select>
                  </Form.Group>
                </div>
              </div>

              {selectedElement && (
                <>
                  <div style={{ display: 'flex', gap: '20px', alignItems: 'center', marginBottom: '1rem' }}>
                    <div className="range-container" style={{ flex: 1 }}>
                      <Form.Label className="range-label">
                        Position X: <span className="fw-bold">{Math.round(formData[selectedElement].x)}px</span>
                      </Form.Label>
                      <input
                        type="range"
                        value={formData[selectedElement].x}
                        onChange={e => handleStyleChange(selectedElement, {
                          ...formData[selectedElement],
                          x: parseInt(e.target.value)
                        })}
                        min="0"
                        max={800}
                        step="1"
                        className="form-range custom-range"
                      />
                    </div>

                    <div className="range-container" style={{ flex: 1 }}>
                      <Form.Label className="range-label">
                        Position Y: <span className="fw-bold">{Math.round(formData[selectedElement].y)}px</span>
                      </Form.Label>
                      <input
                        type="range"
                        value={formData[selectedElement].y}
                        onChange={e => handleStyleChange(selectedElement, {
                          ...formData[selectedElement],
                          y: parseInt(e.target.value)
                        })}
                        min="0"
                        max={400}
                        step="1"
                        className="form-range custom-range"
                      />
                    </div>

                    <div className="range-container" style={{ flex: 1 }}>
                      <Form.Label className="range-label">
                        Taille: <span className="fw-bold">{formData[selectedElement].fontSize}px</span>
                      </Form.Label>
                      <input
                        type="range"
                        value={formData[selectedElement].fontSize}
                        onChange={e => handleStyleChange(selectedElement, {
                          ...formData[selectedElement],
                          fontSize: parseInt(e.target.value)
                        })}
                        min="8"
                        max="36"
                        step="1"
                        className="form-range custom-range"
                      />
                    </div>
                  </div>

                  {selectedElement === 'positionsMontantLettre' && (
                    <div style={{ display: 'flex', gap: '20px', alignItems: 'center', marginBottom: '1rem' }}>
                      <div className="range-container" style={{ flex: 1 }}>
                        <Form.Label className="range-label">
                          Ligne n°: <span className="fw-bold">{formData.positionsMontantLettre.lineNumber || 1}</span>
                        </Form.Label>
                        <input
                          type="range"
                          value={formData.positionsMontantLettre.lineNumber || 1}
                          onChange={e => handleStyleChange('positionsMontantLettre', {
                            ...formData.positionsMontantLettre,
                            lineNumber: parseInt(e.target.value),
                          })}
                          min="1"
                          max="5"
                          step="1"
                          className="form-range custom-range"
                        />
                      </div>

                      <div className="range-container" style={{ flex: 1 }}>
                        <Form.Label className="range-label">
                          Caractères max: <span className="fw-bold">{formData.positionsMontantLettre.caracter || 0}</span>
                        </Form.Label>
                        <input
                          type="range"
                          value={formData.positionsMontantLettre.caracter || 0}
                          onChange={e => handleStyleChange('positionsMontantLettre', {
                            ...formData.positionsMontantLettre,
                            caracter: parseInt(e.target.value),
                          })}
                          min="0"
                          max="80"
                          step="1"
                          className="form-range custom-range"
                        />
                      </div>
                    </div>
                  )}

                  <div className="range-container" style={{ maxWidth: '330px', marginBottom: '1rem' }}>
                    <Form.Label className="range-label">Police</Form.Label>
                    <select
                      value={formData[selectedElement].fontFamily}
                      onChange={e => handleStyleChange(selectedElement, {
                        ...formData[selectedElement],
                        fontFamily: e.target.value
                      })}
                      className="form-select"
                    >
                      <option value="Arial">Arial</option>
                      <option value="Times New Roman">Times New Roman</option>
                      <option value="Courier New">Courier New</option>
                      <option value="Verdana">Verdana</option>
                    </select>
                  </div>
                </>
              )}
            </div>

     <div className="mb-4">
  <Form.Group>
    <Form.Label className="fw-bold">
      <FaImage className="me-2" /> Modèle de chèque
    </Form.Label>
    <Form.Control
      type="file"
      onChange={handleImageChange}
      accept="image/*"
      style={{ width: '40%' }}
    />
  </Form.Group>
</div>


            <div
              className="cheque-preview-container mb-4 border rounded position-relative"
              style={{
                width: '794px',
                height: '1123px',
                overflow: 'hidden',
                margin: '0 auto',
                backgroundColor: '#f9f9f9',
              }}
              onMouseMove={(e) => {
                if (!isDragging || !dragField) return;
                const rect = e.currentTarget.getBoundingClientRect();
                const x = e.clientX - rect.left - dragOffset.x;
                const y = e.clientY - rect.top - dragOffset.y;

                handleStyleChange(dragField, {
                  ...formData[dragField],
                  x: Math.max(0, Math.min(x, rect.width - 50)),
                  y: Math.max(0, Math.min(y, rect.height - 30))
                });
              }}
              onMouseUp={() => {
                setIsDragging(false);
                setDragField(null);
              }}
              onMouseLeave={() => {
                setIsDragging(false);
                setDragField(null);
              }}
            >
              <div
                className="cheque-background"
                style={{
                  backgroundImage: `url(${formData.chequeImage})`,
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  width: '100%',
                  height: '100%',
                  position: 'absolute',
                  opacity: 0.7,
                  top: 0,
                  left: 0,
                }}
              ></div>

              {Object.keys(formData).filter(key => key.startsWith('position')).map((field) => (
                <div
                  key={field}
                  className={`cheque-element ${selectedElement === field ? 'active-element' : ''}`}
                  style={{
                    position: 'absolute',
                    top: `${formData[field].y}px`,
                    left: `${formData[field].x}px`,
                    fontSize: `${formData[field].fontSize}px`,
                    fontFamily: formData[field].fontFamily,
                    cursor: 'move',
                    padding: '5px 10px',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    border: '1px dashed #666',
                    borderRadius: '4px',
                    userSelect: 'none',
                    zIndex: selectedElement === field ? 10 : 1
                  }}
                  onMouseDown={(e) => {
                    if (e.button !== 0) return;
                    setIsDragging(true);
                    setDragField(field);
                    const rect = e.currentTarget.getBoundingClientRect();
                    setDragOffset({
                      x: e.clientX - rect.left,
                      y: e.clientY - rect.top
                    });
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                >
                  {field === 'positionsMontant' && <FaMoneyBillWave className="me-1" />}
                  {field === 'positionsMontantLettre' && <FaFileSignature className="me-1" />}
                  {field === 'positionorder_a' && <i className="fas fa-user-tag me-1"></i>}
                  {field === 'positionfait_a' && <FaMapMarkerAlt className="me-1" />}
                  {field === 'positionDate' && <FaCalendarAlt className="me-1" />}
                  {field === 'positionType' && <FaFileAlt className="me-1" />}

                  {field === 'positionsMontant' && 'Montant'}
                  {field === 'positionsMontantLettre' && 'Montant en lettres'}
                  {field === 'positionorder_a' && 'Ordre à'}
                  {field === 'positionfait_a' && 'Fait à'}
                  {field === 'positionDate' && 'Date'}
                  {field === 'positionType' && 'Type'}
                </div>
              ))}
            </div>

            <div className="d-flex justify-content-end">
              <Button
                variant="outline-secondary"
                onClick={() => setShowModal(false)}
                className="me-2"
              >
                Annuler
              </Button>
              <Button
                className='waw'
                type="submit"
              >
                {editingId ? 'Mettre à jour' : 'Enregistrer'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PositionEditor;
